import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@strava/ui/Button';

import I18n from 'utils/I18n';

import styles from './index.scss';
import { clearCheckoutError } from '../../../actions';

export const I18nPrefix = 'strava.subscriptions.checkout.form';

export const CheckoutErrorComponent = ({ dispatchClearCheckoutError }) => (
  <div className={styles.checkoutError}>
    <div className={styles.message}>
      <p className="text-center">
        {I18n.t(`${I18nPrefix}.payment_failure.we_are_sorry`)}
      </p>
      <p className="text-center">
        {I18n.t(`${I18nPrefix}.payment_failure.card_not_charged`)}
      </p>
    </div>
    <Button
      type="button"
      variant="primary"
      className={styles.cta}
      onClick={dispatchClearCheckoutError}
    >
      {I18n.t(`${I18nPrefix}.payment_failure.cta`)}
    </Button>
  </div>
);

CheckoutErrorComponent.propTypes = {
  dispatchClearCheckoutError: PropTypes.func.isRequired
};

export default connect(
  undefined,
  {
    dispatchClearCheckoutError: clearCheckoutError
  }
)(CheckoutErrorComponent);
